import { render } from "./EmployeeLogin.vue?vue&type=template&id=4dbc2a44&scoped=true&ts=true"
import script from "./EmployeeLogin.vue?vue&type=script&lang=ts"
export * from "./EmployeeLogin.vue?vue&type=script&lang=ts"

import "./EmployeeLogin.vue?vue&type=style&index=0&id=4dbc2a44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbc2a44"]])

export default __exports__